(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-rewards-earn"] && !Shopify.designMode) return;
  try {
    /**
   * After a variant or product swap (e.g. combined-listing flavour change),
   * the theme morphs the DOM in place. The Bubblehouse MutationObserver only
   * fires for *newly added* nodes, so `populateProductPointsPanel` is never
   * re-invoked and the points value goes blank.
   *
   * Fix: listen for the product:switched event (dispatched by
   * ProductSectionSwitcher after morphing) and the variant:update event,
   * then re-insert the points panel so the Bubblehouse observer picks it up.
   */
  (function () {
    function reinitBubblehousePanel() {
      const panel = document.querySelector('.bubblehouse-product-points-panel');
      if (!panel) return;

      const pointsEl = panel.querySelector('.bubblehouse-product-points-value');
      if (pointsEl && pointsEl.textContent.trim() !== '') return;

      const parent = panel.parentNode;
      if (!parent) return;
      const next = panel.nextSibling;
      parent.removeChild(panel);
      parent.insertBefore(panel, next);
    }

    // Flavour switches via ProductSectionSwitcher
    document.addEventListener('product:switched', () => {
      requestAnimationFrame(reinitBubblehousePanel);
    });

    // Same-product variant changes (e.g. size switch)
    document.addEventListener('variant:update', () => {
      requestAnimationFrame(reinitBubblehousePanel);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    (function() {
    function updateSnackersText(ratingContainer) {
      var ratingSummary = ratingContainer.querySelector('[data-bv-show="rating_summary"]');
      var inlineRating = ratingContainer.querySelector('.inline-rating[data-bv-show="inline_rating"]');
      var ratingRoot = ratingSummary || inlineRating;
      var snackersEl = ratingContainer.querySelector('.review-rating__snackers');
      if (!ratingRoot || !snackersEl) return false;

      // New BV markup uses .bv_numReviews_text, older markup used .bv_text
      var numReviewsEl = ratingRoot.querySelector('.bv_numReviews_component_container .bv_numReviews_text, .bv_numReviews_component_container .bv_text');
      var count = null;

      if (numReviewsEl) {
        var text = numReviewsEl.textContent.trim();
        var textMatch = text.match(/(\d[\d,]*)/);
        if (textMatch) count = textMatch[1];
      }

      // Fallback for rating_summary markup where review count is provided in meta
      if (!count) {
        var reviewCountMeta = ratingRoot.querySelector('meta[itemprop="reviewCount"]');
        if (reviewCountMeta && reviewCountMeta.content) {
          var metaCount = reviewCountMeta.content.trim();
          var metaMatch = metaCount.match(/^\d[\d,]*$/);
          if (metaMatch) count = metaMatch[0];
        }
      }

      if (!count) return false;

      var template = snackersEl.getAttribute('data-snackers-template') || 'from __COUNT__ snackers';
      snackersEl.textContent = template.replace('__COUNT__', count);
      snackersEl.classList.add('is-visible');
      return true;
    }

    // Process all review-rating containers on the page
    function processAll() {
      var containers = document.querySelectorAll('.review-rating');
      var allDone = true;
      containers.forEach(function(container) {
        var snackersEl = container.querySelector('.review-rating__snackers');
        if (!snackersEl || snackersEl.classList.contains('is-visible')) return;

        if (!updateSnackersText(container)) {
          allDone = false;
        }
      });
      return allDone;
    }

    // Try immediately
    if (processAll()) return;

    // Observe for BV to populate the inline rating
    var observer = new MutationObserver(function() {
      if (processAll()) observer.disconnect();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'aria-expanded']
    });

    // Safety timeout
    setTimeout(function() { observer.disconnect(); }, 30000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["usp-list"] && !Shopify.designMode) return;
  try {
    // Clone marquee items for seamless loop and set speed to match marquee section
  document.querySelectorAll('.usp-list--marquee .usp-list__track, .usp-list--marquee-mobile .usp-list__track').forEach(track => {
    const items = [...track.children];
    items.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
      track.appendChild(clone);
    });

    // Calculate exact scroll distance: position of first clone = original content width + gaps
    const firstClone = track.children[items.length];
    const scrollDist = firstClone ? firstClone.offsetLeft : track.scrollWidth / 2;

    // Set pixel-based end position (CSS % in transforms is relative to offsetWidth, not scrollWidth)
    track.style.setProperty('--usp-marquee-scroll', `-${scrollDist}px`);

    // Match native marquee px/s rate (~55px/s)
    const duration = Math.max(scrollDist / 55, 3);
    track.style.animationDuration = `${duration}s`;
  });
  } catch(e) { console.error(e); }
})();

})();
